import $ from 'jquery';
import 'slick-carousel';
import { forceLazyLoad } from '../global/helpers';

const peopleAwards = {
	init() {
		// Bind this.sameHeightSlides to this object.
		this.sameHeightSlides = this.sameHeightSlides.bind(this);

		const _this = this;
		const $carousels = $('.js-people-awards-carousel');
		$carousels.each(function () {
			const $carousel = $(this);
			// Force images to lazy load.
			forceLazyLoad($carousel);
			// Init slick.
			$carousels.slick({
				adaptiveHeight: true,
				slidesToShow: 4,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
						},
					},
					{
						breakpoint: 950,
						settings: {
							slidesToShow: 3,
						},
					},
				],
			});

			// Make all slides the same height.
			_this.sameHeightSlides($carousel);
			// Make sure slides stay the same height.
			$carousel.on('setPosition', () => {
				_this.sameHeightSlides($carousel);
			});
		});
	},

	sameHeightSlides($carousel) {
		// Setup reused elements.
		const $slides = $carousel.find('.slick-slide');
		const $slickList = $carousel.find('.slick-list');
		const $slickTrack = $carousel.find('.slick-track');

		// Set height of slides and track to auto.
		$slides.height('auto');
		$slickList.height('auto');

		// Get slick track height now that it's auto.
		const slickTrackHeight = $slickTrack.height();

		// Set each slide's height to the height of slick track.
		$slides.css({
			height: `${slickTrackHeight}px`,
		});
	},
};

peopleAwards.init();
